<template>
	<div class="wrapper">
		<v-top></v-top>
		<v-head :navData="navData" :activeIndex="defaultRoute"></v-head>
		<v-nav :navData="navData" :activeIndex="defaultRoute"></v-nav>
		<!-- 补偿头部返回条的高度 -->
		<div v-if="pageHead.isShow && false" style="margin-top: 60px;"></div>
		<div class="content">
			<transition name="move" mode="out-in">
				<!-- <keep-alive :include="tagsList"> -->
					<router-view>
						<template v-if="showLeftBar" #home-leftbar>
							<div class="home-LeftBar">
								<div class="block navList">
									<div class="title">用户中心</div>
									<div class="list">
										<div
											v-for="(item, index) of arr_LeftBar_Item"
											class="item" :class="{ 'item--Active': $route && $route.name === item.routeName }"
											@click="userClick(item.routeName)"
										>
											{{item.name}}<div class="active-Bar"></div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</router-view>
				<!-- </keep-alive> -->
			</transition>
		</div>
		<v-footer></v-footer>
		
		<div class="fixed-Home">
			<div v-show="img_Kefu" class="QRCode_Kefu">
				<!-- <img src="../../../static/img/QRCode-01.png"/> -->
				<img :src="img_Kefu"/>
			</div>
			<a class="goTop" href="#">
				<i class="icon el-icon-arrow-up"></i>
				Top
			</a>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.fixed-Home {
		$addition-Left: 24px;
		$fixed-Marg-L: calc(1190px / 2 + $addition-Left);
		@mixin fixed-Left() {
			position: fixed;
			left: 50%;
			margin-left: $fixed-Marg-L;
		}
		$btm-GoTop: 10vh;
		$btm-QRCode_Kefu: calc($btm-GoTop + 200px);
		
		.QRCode_Kefu {
			@include fixed-Left();
			z-index: 2;
			bottom: $btm-QRCode_Kefu;
			margin-left: calc($fixed-Marg-L + 24px);
			
			left: unset;
			right: 0;
			
			img {
				width: 120px;
				box-sizing: border-box;
				border: 1px solid $color-Border-01;
				border-radius: 2px;
				object-fit: cover;
			}
		}
		.goTop {
			@include fixed-Left();
			$goTop-SideLen: 44px;
			z-index: 2;
			display: flex;
			justify-content: center;
			flex-direction: column;
			align-items: center;
			width: $goTop-SideLen;
			height: $goTop-SideLen;
			bottom: $btm-GoTop;
			background-color: #000;
			color: #fff;
			font-size: 14px;
			text-decoration: none;
			transition: background-color ease-out .15s;
			
			left: unset;
			right: calc((100% - 1190px) / 2 - 44px);
			
			&:hover {
				background-color: darkred;
			}
			.icon {
				color: #fff;
			}
			@media screen and (max-width: 1190px + $goTop-SideLen * 2) {
				& {
					right: 0;
				}
			}
		}
	}
	
	.content {
		min-height: 60vh;
		background-color: #fff;
		
		.home-LeftBar {
			width: 160px;
			
			.block {
				border: 1px solid $color-Border-01;
				background-color: #fff;
			}
			.navList {
				
				$title-Pad: 20px;
				.title {
					margin: 12px $title-Pad 0;
					box-sizing: border-box;
					padding-bottom: 4px;
					border-bottom: 1px solid $color-Border-01;
					font-size: 16px;
					line-height: 28px;
					font-weight: bold;
				}
				$list-Pad: 10px;
				.list {
					padding: 0 $title-Pad;
					padding-left: $title-Pad + $list-Pad;
					
					.item {
						$LH: 12px;
						position: relative;
						margin: 20px 0;
						box-sizing: border-box;
						font-size: $LH;
						line-height: $LH;
						cursor: pointer;
						
						.active-Bar {
							position: absolute;
							display: none;
							width: 3px;
							height: $LH;
							left: -8px;
							top: 0;
							background-color: $color-Price;
						}
						&--Active {
							color: $color-Price;
							
							.active-Bar {
								display: block;
							}
						}
					}
				}
			}
		}
	}
	
	.wrapper{
	  position: relative;
	  display: flex;
	  flex-direction: column;
	  box-sizing: border-box;
	  min-height: 100%;
	  // background-color: #f5f6f7;
	  // padding-bottom: 100px;
	  // padding-top: 130px;
	}
</style>

<script>
	import vTop from './Topbar.vue';
	import vHead from './Header.vue';
	import vNav from './Nav.vue';
	import vFooter from './Footer.vue';
	
	import { mapGetters } from 'vuex'
	import bus, { Evt_Header } from '../../assets/bus';

	export default {
		components: {
			vTop,
			vHead,
			vNav,
			vFooter
		},
		data() {
			return {
				tagsList: [],
				collapse: false,
				defaultRoute: "",
				navData:[],
				navIndex:"",
				
				arr_LeftBar_Item: [
					{ routeName: 'my', name: '个人中心' },
					{ routeName: 'order', name: '我的订单' },
					{ routeName: 'collect', name: '我的收藏' },
					{ routeName: 'address', name: '地址管理' },
					// { routeName: 'purse', name: '钱包余额' },
					// { routeName: 'kefu', name: '联系客服' },
					// { routeName: 'bindInfo', name: '清关信息' },
					// { routeName: 'inviteCode', name: '邀请码' },
					// { routeName: 'setting', name: '设置' },
					{ routeName: 'history', name: '浏览历史' },
				],
				/** @zh 这些页面要显示 LeftBar菜单 */
				arr_Need_LeftBar: [
					'my',
					'order',
					'collect',
					'address',
					'history',
					'article',
				],
				showLeftBar: false,
				
				img_Kefu: '',
			}
		},
		computed: {
			...mapGetters([
				'userInfo',
				'pageHead'
			])
		},
		watch: {
			$route(to, from) {
				if(to.name=='Index'){
					this.defaultRoute = to.name
				}else{
					this.defaultRoute = to.name+to.query.id
				}
				
				if(to && to.name) {
					this.check_Show_LeftBar(to.name)
				}
			}
		},
		created() {
			if(this.$route.name=='Index'){
				this.defaultRoute = this.$route.name
			}else{
				this.defaultRoute = this.$route.name+this.$route.query.id
			}
			this.getData()
			
			this.check_Show_LeftBar(this.$route.name)
			this.get_Img_Kefu()
		},
		methods: {
			get_Img_Kefu() {
				return this.$server.post('/index.php/AppInterface/My/service_wechat', {
					
				})
				.then(res => {
					if(res.result === 1) {
						if(res.data.service_wechat) {
							this.img_Kefu = res.data.service_wechat.img
						}
						bus.$emit(Evt_Header.Update_RecommendArr, res.data.hot_word)
					}
					else {
						this.$message.warning(res.msg)
					}
				})
				.catch(err => {
					console.error('getData: error =>', err)
					this.$message.error(this.$t('common.require-error'))
				})
			},
			check_Show_LeftBar(cur_Page_Name) {
				const page_Name = this.arr_Need_LeftBar.find(it => it === cur_Page_Name)
				if(page_Name) {
					this.showLeftBar = true
				}
				else {
					this.showLeftBar = false
				}
			},
			getData(){
				let that = this
				that.$showLoading()
				that.$server.post("/index.php/AppInterface/Index/index", {
					token: this.userInfo.token,
				})
				.then(res => {
					that.$hideLoading()
					switch (res.result) {
						case 1:
							// WARNING:
							// item_navigation_list 好像没有返给这项参数？
							// nav_list 的功能应该改为由 terms 来承担了
							that.navData = res.data.item_navigation_list||[]
							if(that.navData.length>0){
								that.navIndex = that.navData[0].term_id
							}
							break;
						default:
							this.$message.warning(res.msg)
							break;
					}
				})
				.catch(err => {
					that.$hideLoading()
					that.$message.error(that.$t('common.require-error'))
				})
			},
			
			// #util
			userClick(type){
				if(type === 'index') {
					this.$router.push("/")
				}
				else if(type=="my") {
					this.$router.push("/my")
				}
				else if(type=="order") {
					this.$router.push("/order")
				}
				else if(type=="collect") {
					this.$router.push("/collect")
				}
				else if(type === 'address') {
					this.$router.push("/address")
				}
				else if(type === 'logout') {
					this.$store.commit('logout')
				}
				else if(type === 'history') {
					this.$router.push("/history")
				}
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Common/Home.vue